"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.createRef = exports.getArrayOfElements = exports.isNodeList = exports.isElement = exports.arrayFrom = exports.isType = void 0;
function isType(value, type) {
    var str = {}.toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
exports.isType = isType;
function arrayFrom(value) {
    return [].slice.call(value);
}
exports.arrayFrom = arrayFrom;
function isElement(value) {
    return ['Element', 'Fragment'].some(function (type) { return isType(value, type); });
}
exports.isElement = isElement;
function isNodeList(value) {
    return isType(value, 'NodeList');
}
exports.isNodeList = isNodeList;
function getArrayOfElements(value) {
    if (isElement(value)) {
        return [value];
    }
    if (isNodeList(value)) {
        return arrayFrom(value);
    }
    if (Array.isArray(value)) {
        return value;
    }
    return arrayFrom(document.querySelectorAll(value));
}
exports.getArrayOfElements = getArrayOfElements;
function createRef(initialValue) {
    return {
        current: initialValue,
    };
}
exports.createRef = createRef;
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
exports.validateEmail = validateEmail;
